import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../shared/base-api-template-service.model';
import {Core2Config} from '../shared/core2Config';
import {AppLoginPrincipalContainerModel} from '../../../../../models/aggregates/app-login';


@Injectable({
  providedIn: 'root'
})
export class TenantIdentityAuthenticationService extends BaseApiTemplateService<AppLoginPrincipalContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'identity/login';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'identity/login';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'identity/login';
    this.httpClient = http;
  }
}